import type { CoverFrameSource } from './buildPreviewStillInputProps';

export type FrameCandidate =
  | { status: 'loading' }
  | { status: 'ready'; dataUrl: string }
  | { status: 'error' };

export type FrameCandidates = Record<CoverFrameSource, FrameCandidate>;

/**
 * Which frame source the chooser has selected. An explicit choice (or the
 * default, the preview frame) sticks while that candidate is loading or
 * ready; a failed candidate hands over to the other one; null when both
 * failed.
 */
export function resolveFrameSourceSelection(
  chosen: CoverFrameSource | null,
  candidates: FrameCandidates,
): CoverFrameSource | null {
  const preferred: CoverFrameSource = chosen ?? 'preview';
  const other: CoverFrameSource = preferred === 'preview' ? 'video' : 'preview';
  if (candidates[preferred].status !== 'error') return preferred;
  if (candidates[other].status !== 'error') return other;
  return null;
}
